import { format, isValid, parseISO } from 'date-fns';
import { cs } from 'date-fns/locale';

/**
 * Safely formats a date value to Czech format (DD.MM.YYYY)
 * Handles null, undefined, invalid dates, and various date formats
 */
export const formatDateSafe = (dateValue: any): string => {
  if (!dateValue || dateValue === 'null' || dateValue === '') {
    return '';
  }

  let date: Date;

  try {
    // If it's already a Date object
    if (dateValue instanceof Date) {
      date = dateValue;
    }
    // If it's a string, try to parse it
    else if (typeof dateValue === 'string') {
      // Try parsing as ISO string first
      if (dateValue.includes('T') || dateValue.includes('Z')) {
        date = parseISO(dateValue);
      } else {
        // Try parsing as regular date string
        date = new Date(dateValue);
      }
    }
    // If it's a number (timestamp)
    else if (typeof dateValue === 'number') {
      date = new Date(dateValue);
    }
    else {
      return '';
    }

    // Check if the date is valid
    if (!isValid(date)) {
      return '';
    }

    return format(date, 'dd.MM.yyyy', { locale: cs });
  } catch (error) {
    console.warn('Date formatting error:', error, 'Value:', dateValue);
    return '';
  }
};

/**
 * Safely formats a date value for date input fields (YYYY-MM-DD)
 */
export const formatDateForInput = (dateValue: any): string => {
  if (!dateValue || dateValue === 'null' || dateValue === '') {
    return '';
  }

  let date: Date;

  try {
    // If it's already a Date object
    if (dateValue instanceof Date) {
      date = dateValue;
    }
    // If it's a string, try to parse it
    else if (typeof dateValue === 'string') {
      // Try parsing as ISO string first
      if (dateValue.includes('T') || dateValue.includes('Z')) {
        date = parseISO(dateValue);
      } else {
        // Try parsing as regular date string
        date = new Date(dateValue);
      }
    }
    // If it's a number (timestamp)
    else if (typeof dateValue === 'number') {
      date = new Date(dateValue);
    }
    else {
      return '';
    }

    // Check if the date is valid
    if (!isValid(date)) {
      return '';
    }

    return date.toISOString().split('T')[0];
  } catch (error) {
    console.warn('Date input formatting error:', error, 'Value:', dateValue);
    return '';
  }
};

/**
 * Checks if a date value is valid and not null/empty
 */
export const hasValidDate = (dateValue: any): boolean => {
  if (!dateValue || dateValue === 'null' || dateValue === '') {
    return false;
  }

  try {
    let date: Date;

    if (dateValue instanceof Date) {
      date = dateValue;
    } else if (typeof dateValue === 'string') {
      if (dateValue.includes('T') || dateValue.includes('Z')) {
        date = parseISO(dateValue);
      } else {
        date = new Date(dateValue);
      }
    } else if (typeof dateValue === 'number') {
      date = new Date(dateValue);
    } else {
      return false;
    }

    return isValid(date);
  } catch (error) {
    return false;
  }
};
